import { Component, Input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'web-design-system-list-toggle',
  templateUrl: './list-toggle.component.html',
  imports: [IconComponent],
})
export class ListToggleComponent {
  @Input() public isCollapsed = false;
}
